import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { experiences } from '../data';

const ProductPage = () => {
  const { id } = useParams();
  const experience = experiences.find((item) => item.id === id);

  if (!experience) {
    return (
      <main className="detail-page not-found">
        <h1>Experience not found</h1>
        <Link to="/">Back to Office Outing</Link>
      </main>
    );
  }

  return (
    <main className="detail-page">
      <section className="detail-hero" style={{ backgroundImage: `linear-gradient(90deg, rgba(0,0,0,.82), rgba(0,0,0,.35)), url(${experience.image})` }}>
        <div>
          <Link to="/" className="back-link">← Back to experiences</Link>
          <p className="eyebrow">{experience.city}, {experience.state}</p>
          <h1>{experience.name}</h1>
          <p>{experience.summary}</p>
        </div>
      </section>

      <section className="detail-content">
        <div className="detail-main">
          <h2>Why it works</h2>
          <p>{experience.details}</p>
          <h2>Best for</h2>
          <p>{experience.bestFor}</p>
          <h2>Planning notes</h2>
          <p> Want help figuring out if this is the right fit? Use the button to request planning support and we’ll help you narrow down options, compare details, and coordinate next steps.</p>
        </div>
        <aside className="detail-sidebar">
          <h3>Quick facts</h3>
          <dl>
            <div><dt>Category</dt><dd>{experience.category}</dd></div>
            <div><dt>Price</dt><dd>{experience.price}</dd></div>
            <div><dt>Group size</dt><dd>{experience.groupSize}</dd></div>
            <div><dt>Duration</dt><dd>{experience.duration}</dd></div>
            <div><dt>Setting</dt><dd>{experience.setting}</dd></div>
          </dl>
         <div className="detail-actions">
  <Link
    to={`/request-booking/${experience.id}`}
    className="button primary full detail-cta-button"
  >
    Request Booking
  </Link>

  <Link
  to="/planning-assistance"
  className="button secondary full detail-cta-button"
>
  Get Planning Assistance
</Link>
</div>
        </aside>
      </section>
    </main>
  );
};

export default ProductPage;
